import React from 'react';

import { useState, useEffect } from 'react';

import makeStyles from '@mui/styles/makeStyles';

import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';

import { ReclamationActionDetailType } from 'constants.js';
import { ReclamationActionDetailCodes } from 'constants.js';

const useStyles = makeStyles((theme) => ({
    formControl: {
        width: '100%',
        marginBottom: theme.spacing(1)
    },
}));



function ReparationAdaptationSurPlace({ onChange, action }) {

    const classes = useStyles();

    const [codePiece, setCodePiece] = useState('');
    const [commentaire, setCommentaire] = useState('');


    useEffect(() => {
        onChange(null);
    }, [onChange]);


    useEffect(() => {


        const getActionData = () => {

            if (codePiece === '' && commentaire === '') {
                return null;
            }

            let actionData =
            {
                code: action.code,
                details: []
            };


            if (codePiece) {
                actionData.details.push({
                    code: ReclamationActionDetailCodes.Commentaire,
                    type: ReclamationActionDetailType.Texte,
                    libelle: "Code pièce",
                    position: actionData.details.length,
                    valeurString: codePiece
                });
            }
            if (commentaire) {
                actionData.details.push({
                    code: ReclamationActionDetailCodes.Commentaire,
                    type: ReclamationActionDetailType.Texte,
                    libelle: "Commentaire",
                    position: actionData.details.length,
                    valeurString: commentaire
                });
            }

            return actionData;
        }


        onChange(getActionData());
    }, [action.code, onChange, codePiece, commentaire]);



    return (
        <DialogContent>

            <TextField className={classes.formControl} value={codePiece} onChange={e => setCodePiece(e.target.value)} variant={"filled"} label={"Code pièce"} />
            <TextField className={classes.formControl} value={commentaire} onChange={e => setCommentaire(e.target.value)} variant={"filled"} label={"Commentaire"} multiline />

        </DialogContent>
    );

}


export default ReparationAdaptationSurPlace;